import { Node, mergeAttributes, PasteRule } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import PlaceholderView from "./PlaceholderView.vue";

export const TiptapPlaceholder = Node.create({
    name: 'placeholder',
    addOptions() {
        return {
            HTMLAttributes: {},
            suggestion: {
                char: '@',
                allowedPrefixes: null,
                command: ({ editor, range, props }) => {
                    editor
                        .chain()
                        .focus()
                        .insertContentAt(range, [
                            {
                                type: 'placeholder',
                                attrs: props,
                            },
                        ])
                        .run();
                },
                allow: ({ editor, range }) => {
                    return editor.can().insertContentAt(range, { type: 'placeholder' });
                },
            },
        };
    },
    group: 'inline',
    inline: true,
    selectable: true,
    draggable: true,
    atom: true,
    addAttributes() {
        return {
            key: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('data-key');
                },
                renderHTML: attributes => {
                    if (!attributes.key) return undefined;
                    return {
                        'data-key': attributes.key,
                    };
                },
            }
        };
    },
    parseHTML() {
        return [
            {
                tag: 'placeholder-view',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ["placeholder-view", mergeAttributes(HTMLAttributes)];
    },
    addNodeView() {
        return VueNodeViewRenderer(PlaceholderView);
    },
    renderText({ node }) {
        return "{{" + node.attrs.key + "}}";
    },
    addPasteRules() {
        return [
            new PasteRule({
                find: /{{([^}]+)}}/gi,
                handler: ({ chain, range, match }) => {
                    const key = match[1];
                    chain().insertContentAt(range, {
                        type: 'placeholder',
                        attrs: {
                            key: key
                        }
                    }).run();
                },
            })
        ]
    },
    addKeyboardShortcuts() {
        return {
            Backspace: () => this.editor.commands.command(({ tr, state }) => {
                let isPlaceholder = false;
                const { selection } = state;
                const { empty, anchor } = selection;
                if (!empty) {
                    return false;
                }
                state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
                    if (node.type.name === this.name) {
                        isPlaceholder = true;
                        tr.insertText("", pos, pos + node.nodeSize);
                        return false;
                    }
                });
                return isPlaceholder;
            }),
        };
    },
    addProseMirrorPlugins() {
        return [
            Suggestion(Object.assign({ editor: this.editor }, this.options.suggestion)),
        ];
    },
});